/**
 * Utility function to remove double-quotes from beginning and end of string.
 * @param str
 * @returns {string}
 */
export const stripDoubleQuotes = (str) => {
    if (str.indexOf('"') === 0) {
        str = str.substring(1);
    }
    if (str.lastIndexOf('"') === str.length - 1) {
        str = str.substring(0, str.length - 1);
    }
    return str;
};